//@flow

export const inAppNotificationActionTypes = {
  SHOW_IN_APP_NOTIFICATION: "SHOW_IN_APP_NOTIFICATION",
  HIDE_IN_APP_NOTIFICATION: "HIDE_IN_APP_NOTIFICATION"
};
export type InAppNotificationActionType = $Keys<typeof inAppNotificationActionTypes>;
